import {
  CUSTOMER_JOURNEY_EVENTS_CATEGORY,
  CUSTOMER_JOURNEY_EVENTS_CATEGORY_ERROR,
  CUSTOMER_JOURNEY_EVENTS_CATEGORY_SUCCESS,
  SET_LANG,
  SET_TOKEN
} from './../../actions/const';

import CustomerJourneySource from './../../sources/CustomerJourneySource';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  apiData: [],
  loading: false,
  catId: null
};

function reducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case CUSTOMER_JOURNEY_EVENTS_CATEGORY: {
      nextState.loading = true;
      nextState.apiData = [];
      nextState.catId = action.catId;
      CustomerJourneySource.eventsCategory(action.catId, action.token, action.lang, action.context);
      return nextState;
    }
    case CUSTOMER_JOURNEY_EVENTS_CATEGORY_SUCCESS: {
      nextState.loading = false;
      nextState.apiData = action.data;
      return nextState;
    }
    case CUSTOMER_JOURNEY_EVENTS_CATEGORY_ERROR: {
      nextState.loading = false;
      nextState.apiData = [];
      return nextState;
    }
    case SET_TOKEN:
    case SET_LANG: {
      if (!isEmpty(state.apiData)) {
        nextState.loading = true;
        nextState.apiData = [];
        CustomerJourneySource.eventsCategory(nextState.catId, action.token, action.lang, action.context);
        return nextState;
      } else {
        return state;
      }
    }
    default: {
      /* Return original state if no actions were consumed. */
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/customerJourney/eventsCategory.js